import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
    .product-details-page {
        .product-details-area {
            padding: 70px 0 65px;

            .product-top-navbar {
                margin-bottom: 20px;
            }

            .product-link {
                color: inherit;
                font-weight: normal;
                font-size: 1.25rem;
            }

            .product-link:hover {
                text-decoration: underline;
            }

            .product-text {
                font-weight: normal;
            }

            .product-slider {
                position: relative;
                overflow: hidden;
                border-radius: 5px;
                border: 1px solid #c7c7c7;
                box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

                .img-fluid {
                    max-width: 100%;
                    transition: transform 0.3s ease;
                    transform-origin: center center;
                }

                .img-fluid:hover {
                    transform: scale(1.3);
                }

                @media(max-width: 767px) {
                    margin-bottom: 25px;
                }
            }

            .product-information {
                margin-top: 15px;

                .product-title {
                    h4 {
                        color: ${colors.black1};
                        font-weight: 600;
                        margin-bottom: 12px;

                        @media(max-width: 575px) {
                            font-size: 20px;
                        }
                    }
                }

                .product-price {
                    margin-bottom: 15px;

                    p.dc-price {
                        font-size: 20px;
                        color: ${colors.green};
                        font-weight: 500;
                    }

                    p.ac-price {
                        font-size: 14px;
                        color: ${colors.text3};
                        font-weight: normal;
                        text-decoration: line-through;
                        margin-left: 15px;
                        margin-top: 12px;

                        @media(max-width: 575px) {
                            margin-top: 6px;
                        }
                    }
                }

                .product-desc {
                    margin-bottom: 20px;

                    p {
                        font-size: 14px;
                        color: ${colors.text3};
                        line-height: 25px;
                    }
                }

                @media(max-width: 991px) {
                    margin-top: 0;
                }
            }

            .product-tab {
                margin-top: 40px;

                .nav {
                    display: inline-block;
                    border-radius: 5px;
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
                    margin-bottom: 35px;

                    .nav-item {
                        display: inline-block;

                        a.nav-link {
                            font-size: 14px;
                            color: ${colors.black2};
                            font-weight: 500;
                            padding: 12px 30px 10px;
                            border-radius: 5px;
                        }

                        a.nav-link.active {
                            background: ${colors.gr_bg};
                            color: #ffffff;
                        }
                    }
                }

                .tab-content {
                    .additional-tab {
                        table.table.table-bordered {
                            margin-bottom: 0;
                            border: 1px solid ${colors.border1};

                            .details-row {
                                height: 150px;
                                vertical-align: top;
                            }

                            .width-40 {
                                width: 30%;
                            }

                            .width-60 {
                                width: 70%;
                            }

                            tr {
                                td {
                                    border: 1px solid ${colors.border1};
                                    font-size: 14px;
                                    color: ${colors.text3};
                                    padding: 12px 18px;

                                    &:first-child {
                                        color: ${colors.black1};
                                    }
                                }
                            }
                        }

                        a.readmore-btn {
                            font-size : 14px;
                            color     : #fff;
                            background: ${colors.gr_bg};
                            display   : inline-block;
                            width     : 245px;
                            height    : 40px;
                            text-align: center;
                            padding   : 11px;
                            border-radius : 5px;
                            margin-top: 40px;

                            &:hover {
                                background: ${colors.gr_bg2};
                            }

                            @media(max-width: 575px) {
                                margin-top : 0;
                            }
                        }
                    }
                }
            }

            @media(max-width: 767px) {
                padding: 35px 0 30px;
            }
        }
    }
`;